import axios from "../../axiosInstance";
import type { PathAssignmentRequest } from "@/modules/learningCenter/features/BadgeManagement/types/badge.types";

interface AssignmentResponse {
  success: boolean;
  pathId: string;
}

export const assignBadgeToPath = async (data: PathAssignmentRequest): Promise<AssignmentResponse> => {
  const response = await axios.post<AssignmentResponse>(
    `/api/badges/${data.badgeId}/assign-to-path`,
    { path_id: data.pathId }
  );
  return response.data;
};

export default assignBadgeToPath;
